module.exports = __webpack_public_path__ + "media/military/military_hc_btn-9b25d5f2.png";